export const es = {
  // Common
  'app.name': 'Máquina de Implantes Dentales',
  'app.shortName': 'DIM',
  'app.footer': '© {year} Máquina de Implantes Dentales. Todos los derechos reservados.',
  
  // Auth
  'auth.login': 'Iniciar Sesión',
  'auth.register': 'Registrarse',
  'auth.forgotPassword': '¿Olvidaste tu contraseña?',
  'auth.email': 'Correo electrónico',
  'auth.password': 'Contraseña',
  'auth.confirmPassword': 'Confirmar contraseña',
  'auth.firstName': 'Nombre',
  'auth.lastName': 'Apellido',
  'auth.name': 'Nombre',
  'auth.submit': 'Enviar',
  'auth.resetPassword': 'Restablecer Contraseña',
  'auth.backToLogin': 'Volver al Inicio de Sesión',
  'auth.welcomeBack': 'Bienvenido de Nuevo',
  'auth.pleaseLogin': 'Por favor inicie sesión en su cuenta',
  'auth.rememberMe': 'Recordarme',
  'auth.or': 'o',
  'auth.dontHaveAccount': '¿No tiene una cuenta?',
  'auth.registerNow': 'Regístrese ahora',
  'auth.required': 'es requerido',
  'auth.invalid': 'no es válido',
  'auth.passwordsDoNotMatch': 'Las contraseñas no coinciden',
  'auth.alreadyHaveAccount': '¿Ya tiene una cuenta?',
  'auth.createAccount': 'Crear Cuenta',
  'auth.fillDetails': 'Por favor complete sus datos',
  'auth.forgotPasswordDesc': 'Ingrese su correo electrónico para restablecer su contraseña',
  'auth.checkEmail': 'Revise su Correo',
  'auth.resetInstructions': 'Hemos enviado instrucciones para restablecer su contraseña a su correo electrónico.',
  'auth.resetEmailSent': '¡Las instrucciones para restablecer la contraseña han sido enviadas a su correo!',
  'auth.resetEmailFailed': 'Error al enviar las instrucciones. Por favor intente nuevamente.',
  'auth.loginSuccess': 'Inicio de sesión exitoso',
  'auth.registerSuccess': 'Registro exitoso',
  'auth.registerError': 'Error en el registro. Por favor intente nuevamente.',
  'auth.logoutSuccess': 'Sesión cerrada exitosamente',
  'auth.invalidCredentials': 'El correo electrónico o la contraseña son incorrectos.',
  'auth.passwordMinLength': 'La contraseña debe tener al menos 8 caracteres',
  'auth.agreeToTerms': 'Debe aceptar los términos y condiciones',
  'auth.agreeToTermsText': 'Acepto los Términos y Condiciones y la Política de Privacidad',
  
  // Dashboard
  'dashboard.title': 'Panel de Control',
  'dashboard.masterReport': 'Master Report',
  'dashboard.welcome': 'Bienvenido de nuevo',
  'dashboard.customers': 'Clientes',
  'dashboard.settings': 'Configuración',
  'dashboard.profile': 'Perfil',
  'dashboard.help': 'Ayuda',
  'dashboard.edit.profile': ' Editar Perfil',
  'dashboard.logout': 'Cerrar Sesión',
  'dashboard.activeUsers': 'Usuarios Activos',
  'dashboard.inactiveUsers': 'Usuarios Inactivos',
  'dashboard.totalRevenue': 'Ingresos Totales',
  'dashboard.activeSessions': 'Sesiones Activas',
  'dashboard.recentCustomers': 'Clientes Recientes',
  'dashboard.refresh': 'Actualizar',
  'dashboard.stats': {
    'totalCustomers': 'Total de Clientes',
    'activeCustomers': 'Clientes Activos',
    'newCustomers': 'Nuevos Clientes',
    'revenue': 'Ingresos',
  },
    // Master Report
  'masterReport.title': 'Master Report',
  'masterReport.table.title': 'Master Report',


  'budget.title': 'Budget',
  'budgetPacing.title': 'Budget Pacing',
  'budgetPacing.table.title': 'Budget Pacing',

  // Amber Alerts
  'amberAlert.title': 'Alerta Ámbar',
  'amberAlert.table.title': 'Alerta Ámbar',
  
  // Profile
  'profile.title': 'Perfil',
  
  // Documentation
  'docs.title': 'Documentación de API',
  
  // Admin
  'admin.title': 'Administrador',
  'admin.user': 'Usuario',
  'admin.features': 'Roles',
  'admin.rowLevelSettings': 'Configuración de Nivel de Fila',
  'admin.roles': 'Roles y Permisos',
  'admin.users': 'Usuarios',
  'admin.customers': 'Clientes',
  
  // Theme
  'theme.light': 'Modo Claro',
  'theme.dark': 'Modo Oscuro',
  
  // Language
  'language.en': 'Inglés',
  'language.es': 'Español',

  // Search
  'search.title': 'Buscar',
  'search.placeholder': 'Buscar clientes, pedidos, etc...',

  // Table Columns
  'table.columns.lastLogin': 'Último Inicio de Sesión',
  'table.columns.status': 'Estado',
  'table.columns.actions': 'Acciones',
  'table.columns.name': 'Nombre',
  'table.columns.email': 'Correo Electrónico',
  'table.columns.role': 'Rol',
  'table.columns.createdAt': 'Creado En',
  'table.columns.updatedAt': 'Actualizado En',
  'table.columns.description': 'Descripción',
  'table.columns.type': 'Tipo',
  'table.columns.phone': 'Teléfono',
  'table.columns.address': 'Dirección',
  'table.columns.company': 'Empresa',
  'table.columns.position': 'Cargo',
  'table.columns.department': 'Departamento',
  'table.columns.manager': 'Gerente',
  'table.columns.team': 'Equipo',
  'table.columns.location': 'Ubicación',
  'table.columns.salary': 'Salario',
  'table.columns.startDate': 'Fecha de Inicio',
  'table.columns.endDate': 'Fecha de Fin',
  'table.columns.duration': 'Duración',
  'table.columns.progress': 'Progreso',
  'table.columns.priority': 'Prioridad',
  'table.columns.assignedTo': 'Asignado A',
  'table.columns.dueDate': 'Fecha de Vencimiento',
  'table.columns.tags': 'Etiquetas',
  'table.columns.category': 'Categoría',
  'table.columns.amount': 'Monto',
  'table.columns.currency': 'Moneda',
  'table.columns.paymentMethod': 'Método de Pago',
  'table.columns.transactionId': 'ID de Transacción',
  'table.columns.invoiceNumber': 'Número de Factura',
  'table.columns.orderNumber': 'Número de Orden',
  'table.columns.quantity': 'Cantidad',
  'table.columns.price': 'Precio',
  'table.columns.total': 'Total',
  'table.columns.discount': 'Descuento',
  'table.columns.tax': 'Impuesto',
  'table.columns.shipping': 'Envío',
  'table.columns.trackingNumber': 'Número de Seguimiento',
  'table.columns.carrier': 'Transportista',
  'table.columns.estimatedDelivery': 'Entrega Estimada',
  'table.columns.actualDelivery': 'Entrega Real',
  'table.columns.notes': 'Notas',
  'table.columns.attachments': 'Adjuntos',
  'table.columns.version': 'Versión',
  'table.columns.changes': 'Cambios',
  'table.columns.author': 'Autor',
  'table.columns.reviewer': 'Revisor',
  'table.columns.approvedBy': 'Aprobado Por',
  'table.columns.approvedAt': 'Aprobado En',
  'table.columns.rejectedBy': 'Rechazado Por',
  'table.columns.rejectedAt': 'Rechazado En',
  'table.columns.reason': 'Razón',
  'table.columns.comments': 'Comentarios',
  'table.columns.rating': 'Calificación',
  'table.columns.feedback': 'Comentarios',
  'table.columns.satisfaction': 'Satisfacción',
  'table.columns.resolution': 'Resolución',
  'table.columns.severity': 'Severidad',
  'table.columns.impact': 'Impacto',
  'table.columns.urgency': 'Urgencia',
  'table.columns.reportedBy': 'Reportado Por',
  'table.columns.reportedAt': 'Reportado En',
  'table.columns.resolvedBy': 'Resuelto Por',
  'table.columns.resolvedAt': 'Resuelto En',
  'table.columns.closedBy': 'Cerrado Por',
  'table.columns.closedAt': 'Cerrado En',
  'table.columns.reopenedBy': 'Reabierto Por',
  'table.columns.reopenedAt': 'Reabierto En',
  'table.columns.lastUpdatedBy': 'Última Actualización Por',
  'table.columns.lastUpdatedAt': 'Última Actualización En',

  voice: {
    tooltip: 'Control de Voz',
    listening: 'Escuchando...',
    notSupported: 'El control por voz no es compatible con su navegador',
    error: 'Error con el reconocimiento de voz',
    navigating: 'Navegando...',
    unknownCommand: 'Comando desconocido. Intente decir "abrir panel" o "ir a usuarios"',
  },
} as const 